import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch, useSelector } from "react-redux";
import { uploadFileApi } from "../services/UploadFile";
import {
  Box,
  Grid,
  Button,
  Tooltip,
  IconButton,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ClipLoader from "react-spinners/ClipLoader";
import { CSSProperties } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { pushNotification, setProposalData } from "../redux/actions";
import CONSTANTS from "../constants/constants";
import { deleteDocument, downloadFile } from "../services/DocumentService";
import Colors from "../theme/colors.json";

const useStyles = makeStyles((theme) => ({
  fileUploadContainer: {
    width: "100%",
  },
  fileDisplayConatiner: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid  #C3C3C3",
    borderRadius: "15px",
    padding: "1%",
    backgroundColor: Colors.WHITE_BACKGROUND,
  },
  fileTitle: {
    width: "35%",
    wordWrap: "break-word",
  },
  DocumentTitleContainer: {
    display: "flex",
    fontSize: theme.fontSizes.SMALL,
    fontWeight: 600,
    paddingBottom: "2%",
  },
  uploadSuccess: {
    color: Colors.GREEN,
  },
  uploadFailed: {
    color: Colors.RED,
  },
}));

const FileUpload = ({ title, handleFile, previousFile }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  //   const [document, setFileData] = useState<any>({});
  const fileTypes = ["JPG", "PNG", "PDF"];
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [document, setDocument] = useState<any>({});

  const handleFileChange = async (file) => {
    setLoading(true);
    setFile(file);
    const response: any = await uploadFileApi(
      file.name,
      file,
      "insurproPolicyData",
      {
        docCategory: file.type,
        userId: sessionStorage.getItem("user-id") || "",
        sourceApp: "insurpro",
      }
    );

    if (response?.success) {
      let data = {
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
        documentId: response.data.id,
        status: response.success,
      };

      setDocument(data);
      handleFile(data);
      setLoading(false);
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );
    } else {
      setFile(null);
      handleFile({
        fileName: "",
        fileType: "",
        fileSize: "",
        documentId: "",
        status: "",
      });
      setLoading(false);
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.ERROR,
          message: response?.message,
        })
      );
    }
  };

  const downloadAttachment = async (id, name) => {
    const response = await downloadFile(id, name);
  };

  const deleteFile = async (id) => {
    const response = await deleteDocument(id);
    setDocument({
      fileName: "",
      fileType: "",
      fileSize: "",
      documentId: "",
      status: "",
    });
    handleFile({
      fileName: "",
      fileType: "",
      fileSize: "",
      documentId: "",
      status: "",
    });
  };

  useEffect(() => {
    setDocument(previousFile);
  }, []);

  return (
    <div className={classes.fileUploadContainer}>
      <div className={classes.DocumentTitleContainer}>{title}</div>
      {loading && <CircularProgress color="primary" />}

      <div>
        {!document?.documentId && !loading && (
          <FileUploader
            handleChange={handleFileChange}
            name="file"
            types={fileTypes}
          />
        )}

        {document?.documentId && !loading && (
          <div className={classes.fileDisplayConatiner}>
            {document.fileType === "image/png" && (
              <img
                style={{ height: "50px", width: "50px" }}
                src="https://cdn-icons-png.flaticon.com/512/337/337948.png"
              />
            )}
            {document.fileType === "application/pdf" && (
              <img
                style={{ height: "50px", width: "50px" }}
                src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
              />
            )}
            {document.fileType === "image/jpg" && (
              <img
                style={{ height: "50px", width: "50px" }}
                src="https://www.svgrepo.com/show/255826/jpg.svg"
              />
            )}
            {document.fileType === "doc" && (
              <img
                style={{ height: "50px", width: "50px" }}
                src="https://www.svgrepo.com/show/255810/doc.svg"
              />
            )}

            {document.fileType === "text/csv" && (
              <img
                style={{ height: "50px", width: "50px" }}
                src="https://cdn-icons-png.flaticon.com/512/172/172534.png"
              />
            )}

            {document.fileType === "image/jpeg" && (
              <img
                style={{ height: "50px", width: "50px" }}
                src="https://cdn-icons-png.flaticon.com/512/337/337940.png"
              />
            )}

            {document.fileType === "text/plain" && (
              <img
                style={{ height: "50px", width: "50px" }}
                src="https://cdn-icons-png.flaticon.com/512/2656/2656402.png"
              />
            )}

            {document.fileType ===
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document" && (
              <img
                style={{ height: "50px", width: "50px" }}
                src="https://img.icons8.com/external-fauzidea-flat-fauzidea/256/external-docx-file-file-extension-fauzidea-flat-fauzidea.png"
              />
            )}

            {document.fileType ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" && (
              <img
                style={{ height: "50px", width: "50px" }}
                src="https://cdn-icons-png.flaticon.com/512/9496/9496502.png"
              />
            )}

            <div className={classes.fileTitle}>{document.fileName}</div>
            <div>
              <IconButton
                onClick={() =>
                  downloadAttachment(document.documentId, document.fileName)
                }
              >
                <FileDownloadOutlinedIcon color="secondary" />
              </IconButton>
            </div>
            <div>
              <IconButton
                onClick={() => deleteFile(document.documentId)}
                color="primary"
              >
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            </div>

            <div>
              {document.status ? (
                <Tooltip title={"Success"}>
                  <IconButton>
                    <CheckCircleIcon className={classes.uploadSuccess} />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={"Failed"}>
                  <IconButton>
                    <ErrorIcon className={classes.uploadFailed} />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUpload;
